export default __webpack_public_path__ + "static/media/fatspaceship.352dddc7.png";